import { Time } from '@angular/common';

export class WorkingHour {
  day: number;
  //fromTime: Date = new Date(new Date().setHours(8, 0));
  //toTime: Date = new Date(new Date().setHours(17, 0));
  fromTime: string = "08:00 AM";
  toTime: string = "08:00 PM";
}
